import React from 'react'
import LeftSideNavaBarAdmin from './LeftSideNavaBarAdmin'

const DeliveryMangement = () => {
  return (
    <div>
        <div class="content-wrapper">
         
         <div class="breadcrumb-wrap bg-f br-1">
             <div class="container">
                 <div class="breadcrumb-title">
                     <h2>Admin</h2>
                     <ul class="breadcrumb-menu list-style">
                         <li><a href="index.html">Home </a></li>
                         <li>Admin</li>
                     </ul>
                 </div>
             </div>
         </div>
       

 <div class="blog-wrap pt-40">
    <div class="container">
       <div class="row gx-5">
             <LeftSideNavaBarAdmin/>

             <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
                         DeliveryMangement  {/* kavana you should write code here */}
                     </div>
              
         </div>
     </div>   
 </div>          
</div>

    </div>
  )
}

export default DeliveryMangement
